function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1904(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 31.87,
    height: 20.12,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.3533333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.935,
    y: 10.06
  }, "\n        Echols\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 20.12,
    width: 31.87,
    height: 20.12,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.8742857142857146
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.935,
    y: 30.18
  }, "\n        Quitman\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 40.24,
    width: 31.87,
    height: 22.94,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.7646153846153847
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.935,
    y: 51.71
  }, "\n        Chattahoochee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 63.18,
    width: 31.87,
    height: 28,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.935,
    y: 77.18
  }, "\n        Charlton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 91.18,
    width: 31.87,
    height: 29.76,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.251428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.935,
    y: 106.06
  }, "\n        Webster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 120.94,
    width: 31.87,
    height: 34.47,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.3116666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.935,
    y: 138.175
  }, "\n        Miller\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 155.41,
    width: 31.87,
    height: 34.94,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.9675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.935,
    y: 172.88
  }, "\n        Dade\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 190.35,
    width: 31.87,
    height: 39.18,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.98375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.935,
    y: 209.94
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 229.53,
    width: 31.87,
    height: 39.53,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.98375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.935,
    y: 249.29500000000002
  }, "\n        McIntosh\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 269.06,
    width: 31.87,
    height: 42.12,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.552857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.935,
    y: 290.12
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 311.18,
    width: 31.87,
    height: 42.71,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.3116666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.935,
    y: 332.535
  }, "\n        Schley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 353.88,
    width: 31.87,
    height: 43.41,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.98375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.935,
    y: 375.585
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 397.29,
    width: 31.87,
    height: 46.35,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.552857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.935,
    y: 420.46500000000003
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 443.65,
    width: 31.87,
    height: 49.53,
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.98375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.935,
    y: 468.41499999999996
  }, "\n        Glascock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 493.18,
    width: 31.87,
    height: 50.24,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.3116666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.935,
    y: 518.3
  }, "\n        Twiggs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 543.41,
    width: 31.87,
    height: 50.94,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.9675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.935,
    y: 568.88
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 594.35,
    width: 31.87,
    height: 52.59,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.3116666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.935,
    y: 620.645
  }, "\n        Milton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 646.94,
    width: 31.87,
    height: 53.06,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.3116666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.935,
    y: 673.47
  }, "\n        Clinch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.87,
    y: 0,
    width: 37.99,
    height: 44.72,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.331666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 50.865,
    y: 22.36
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 69.86,
    y: 0,
    width: 38.24,
    height: 44.72,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.648000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 88.98,
    y: 22.36
  }, "\n        Bryan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 108.11,
    y: 0,
    width: 38.49,
    height: 44.72,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.498571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 127.355,
    y: 22.36
  }, "\n        Catoosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.6,
    y: 0,
    width: 38.66,
    height: 44.72,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.886666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 165.93,
    y: 22.36
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 185.26,
    y: 0,
    width: 38.91,
    height: 44.72,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.781999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 204.71499999999997,
    y: 22.36
  }, "\n        Heard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 224.17,
    y: 0,
    width: 39.67,
    height: 44.72,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.667142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 244.005,
    y: 22.36
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 263.84,
    y: 0,
    width: 40.59,
    height: 44.72,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.07375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 284.135,
    y: 22.36
  }, "\n        McDuffie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 304.43,
    y: 0,
    width: 41.01,
    height: 44.72,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.202
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 324.935,
    y: 22.36
  }, "\n        Rabun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 345.43,
    y: 0,
    width: 41.93,
    height: 44.72,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.658888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 366.395,
    y: 22.36
  }, "\n        Effingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 387.36,
    y: 0,
    width: 42.52,
    height: 44.72,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.086666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 408.62,
    y: 22.36
  }, "\n        Pierce\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 429.88,
    y: 0,
    width: 43.61,
    height: 44.72,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.845555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 451.685,
    y: 22.36
  }, "\n        Dougherty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 473.49,
    y: 0,
    width: 43.78,
    height: 44.72,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.296666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 495.38,
    y: 22.36
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 517.27,
    y: 0,
    width: 45.37,
    height: 44.72,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.943999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 539.9549999999999,
    y: 22.36
  }, "\n        Baker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 562.63,
    y: 0,
    width: 45.62,
    height: 44.72,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.453333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 585.4399999999999,
    y: 22.36
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 608.26,
    y: 0,
    width: 45.7,
    height: 44.72,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.453333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 631.11,
    y: 22.36
  }, "\n        Dawson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 653.96,
    y: 0,
    width: 46.04,
    height: 44.72,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.453333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 676.98,
    y: 22.36
  }, "\n        Oconee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.87,
    y: 44.72,
    width: 48.77,
    height: 43.21,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.172857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.255,
    y: 66.325
  }, "\n        Clayton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.87,
    y: 87.93,
    width: 48.77,
    height: 43.44,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.687999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.255,
    y: 109.65
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.87,
    y: 131.38,
    width: 48.77,
    height: 43.6,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.45
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.255,
    y: 153.18
  }, "\n        Campbell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.87,
    y: 174.97,
    width: 48.77,
    height: 44.98,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.496666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.255,
    y: 197.46
  }, "\n        Talbot\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.87,
    y: 219.96,
    width: 48.77,
    height: 45.6,
    style: {
      fill: "#000033"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.6000000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.255,
    y: 242.76000000000002
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.87,
    y: 265.55,
    width: 48.77,
    height: 46.52,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.645714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.255,
    y: 288.81
  }, "\n        Baldwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.87,
    y: 312.07,
    width: 48.77,
    height: 47.14,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.8566666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.255,
    y: 335.64
  }, "\n        Brooks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.87,
    y: 359.21,
    width: 48.77,
    height: 47.29,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.881666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.255,
    y: 382.85499999999996
  }, "\n        Murray\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.87,
    y: 406.5,
    width: 48.77,
    height: 48.06,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.612
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.255,
    y: 430.53
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.87,
    y: 454.56,
    width: 48.77,
    height: 48.29,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.898571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.255,
    y: 478.705
  }, "\n        Liberty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.87,
    y: 502.85,
    width: 48.77,
    height: 48.75,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.964285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.255,
    y: 527.225
  }, "\n        Stewart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.87,
    y: 551.6,
    width: 48.77,
    height: 49.37,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.967142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.255,
    y: 576.285
  }, "\n        Hancock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.87,
    y: 600.96,
    width: 48.77,
    height: 49.52,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.967142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.255,
    y: 625.72
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.87,
    y: 650.48,
    width: 48.77,
    height: 49.52,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.128333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 56.255,
    y: 675.24
  }, "\n        Morgan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.64,
    y: 44.72,
    width: 49.88,
    height: 50,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.313333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 105.58,
    y: 69.72
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 130.52,
    y: 44.72,
    width: 50.03,
    height: 50,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.142857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 155.53500000000003,
    y: 69.72
  }, "\n        Screven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 180.54,
    y: 44.72,
    width: 50.1,
    height: 50,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.555555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 205.59,
    y: 69.72
  }, "\n        Wilkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 230.65,
    y: 44.72,
    width: 50.55,
    height: 50,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.142857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 255.925,
    y: 69.72
  }, "\n        Johnson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 281.2,
    y: 44.72,
    width: 51.6,
    height: 50,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.142857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 307,
    y: 69.72
  }, "\n        Pulaski\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 332.8,
    y: 44.72,
    width: 51.9,
    height: 50,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 358.75,
    y: 69.72
  }, "\n        Taliaferro\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 384.7,
    y: 44.72,
    width: 51.98,
    height: 50,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.25
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 410.69,
    y: 69.72
  }, "\n        Rockdale\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 436.67,
    y: 44.72,
    width: 52.05,
    height: 50,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.333333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 462.695,
    y: 69.72
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 488.72,
    y: 44.72,
    width: 52.05,
    height: 50,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 514.745,
    y: 69.72
  }, "\n        White\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 540.77,
    y: 44.72,
    width: 52.2,
    height: 50,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 566.87,
    y: 69.72
  }, "\n        Early\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 592.97,
    y: 44.72,
    width: 52.95,
    height: 50,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.25
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 619.445,
    y: 69.72
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 645.92,
    y: 44.72,
    width: 54.08,
    height: 50,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.333333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 672.9599999999999,
    y: 69.72
  }, "\n        Jasper\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.64,
    y: 94.72,
    width: 52.65,
    height: 51.85,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.370000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 106.965,
    y: 120.645
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.64,
    y: 146.56,
    width: 52.65,
    height: 52.06,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.412
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 106.965,
    y: 172.59
  }, "\n        Butts\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.64,
    y: 198.62,
    width: 52.65,
    height: 52.49,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.748333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 106.965,
    y: 224.865
  }, "\n        Wilcox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.64,
    y: 251.11,
    width: 52.65,
    height: 53.63,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.58125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 106.965,
    y: 277.925
  }, "\n        Colquitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.64,
    y: 304.74,
    width: 52.65,
    height: 53.77,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.53
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 106.965,
    y: 331.625
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.64,
    y: 358.51,
    width: 52.65,
    height: 55.19,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.521428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 106.965,
    y: 386.105
  }, "\n        Terrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.64,
    y: 413.7,
    width: 52.65,
    height: 55.62,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.53
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 106.965,
    y: 441.51
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.64,
    y: 469.32,
    width: 52.65,
    height: 57.12,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.53
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 106.965,
    y: 497.88
  }, "\n        Dodge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.64,
    y: 526.44,
    width: 52.65,
    height: 57.76,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.58125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 106.965,
    y: 555.32
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.64,
    y: 584.2,
    width: 52.65,
    height: 57.83,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.1625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 106.965,
    y: 613.115
  }, "\n        Ware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 80.64,
    y: 642.03,
    width: 52.65,
    height: 57.97,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.1625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 106.965,
    y: 671.015
  }, "\n        Hart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 133.3,
    y: 94.72,
    width: 55.44,
    height: 55.88,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.088
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 161.02,
    y: 122.66
  }, "\n        Upson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 188.73,
    y: 94.72,
    width: 55.7,
    height: 55.88,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.283333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 216.57999999999998,
    y: 122.66
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 244.44,
    y: 94.72,
    width: 55.77,
    height: 55.88,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.967142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 272.325,
    y: 122.66
  }, "\n        Lumpkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 300.21,
    y: 94.72,
    width: 55.91,
    height: 55.88,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.982857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 328.16499999999996,
    y: 122.66
  }, "\n        Bulloch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 356.11,
    y: 94.72,
    width: 56.04,
    height: 55.88,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.588
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 384.13,
    y: 122.66
  }, "\n        Oglethorpe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 412.15,
    y: 94.72,
    width: 56.64,
    height: 55.88,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.982857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 440.46999999999997,
    y: 122.66
  }, "\n        Telfair\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 468.8,
    y: 94.72,
    width: 57.31,
    height: 55.88,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.176
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 497.45500000000004,
    y: 122.66
  }, "\n        Glynn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 526.11,
    y: 94.72,
    width: 57.65,
    height: 55.88,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.588
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 554.9350000000001,
    y: 122.66
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 583.76,
    y: 94.72,
    width: 57.99,
    height: 55.88,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.313333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 612.755,
    y: 122.66
  }, "\n        Harris\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 641.75,
    y: 94.72,
    width: 58.25,
    height: 55.88,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.982857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 670.875,
    y: 122.66
  }, "\n        Houston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 133.3,
    y: 150.59,
    width: 58,
    height: 57.73,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.247142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 162.3,
    y: 179.455
  }, "\n        Appling\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 133.3,
    y: 208.33,
    width: 58,
    height: 58.44,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.666666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 162.3,
    y: 237.55
  }, "\n        Coffee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 133.3,
    y: 266.77,
    width: 58,
    height: 58.83,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.666666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 162.3,
    y: 296.185
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 133.3,
    y: 325.6,
    width: 58,
    height: 60.13,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.6
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 162.3,
    y: 355.665
  }, "\n        Towns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 133.3,
    y: 385.73,
    width: 58,
    height: 60.84,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.285714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 162.3,
    y: 416.15000000000003
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 133.3,
    y: 446.57,
    width: 58,
    height: 61.35,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.444444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 162.3,
    y: 477.245
  }, "\n        Chattooga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 133.3,
    y: 507.92,
    width: 58,
    height: 62.65,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.5
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 162.3,
    y: 539.245
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 133.3,
    y: 570.57,
    width: 58,
    height: 64.59,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.444444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 162.3,
    y: 602.865
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 133.3,
    y: 635.15,
    width: 58,
    height: 64.85,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.285714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 162.3,
    y: 667.5749999999999
  }, "\n        Emanuel\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 191.3,
    y: 150.59,
    width: 61.48,
    height: 61.3,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.26
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 222.04000000000002,
    y: 181.24
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 252.79,
    y: 150.59,
    width: 61.73,
    height: 61.3,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.216666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 283.655,
    y: 181.24
  }, "\n        Clarke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 314.52,
    y: 150.59,
    width: 62.4,
    height: 61.3,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.216666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 345.71999999999997,
    y: 181.24
  }, "\n        Fannin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 376.92,
    y: 150.59,
    width: 64.05,
    height: 61.3,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.26
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 408.945,
    y: 181.24
  }, "\n        Worth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 440.97,
    y: 150.59,
    width: 64.11,
    height: 61.3,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.216666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 473.02500000000003,
    y: 181.24
  }, "\n        Gordon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 505.09,
    y: 150.59,
    width: 64.54,
    height: 61.3,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.216666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 537.36,
    y: 181.24
  }, "\n        Elbert\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 569.63,
    y: 150.59,
    width: 65.15,
    height: 61.3,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.757142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 602.205,
    y: 181.24
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 634.78,
    y: 150.59,
    width: 65.22,
    height: 61.3,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.6625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 667.39,
    y: 181.24
  }, "\n        Spalding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 191.3,
    y: 211.89,
    width: 68.7,
    height: 58.41,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.681999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 225.65,
    y: 241.09499999999997
  }, "\n        Banks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 191.3,
    y: 270.3,
    width: 68.7,
    height: 59.66,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.522857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 225.65,
    y: 300.13
  }, "\n        Berrien\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 191.3,
    y: 329.96,
    width: 68.7,
    height: 59.99,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.998000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 225.65,
    y: 359.955
  }, "\n        Irwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 191.3,
    y: 389.95,
    width: 68.7,
    height: 61.08,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.18
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 225.65,
    y: 420.49
  }, "\n        Sumter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 102,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 191.3,
    y: 451.03,
    width: 68.7,
    height: 61.14,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.114
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 225.65,
    y: 481.59999999999997
  }, "\n        Meriwether\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 103,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 191.3,
    y: 512.17,
    width: 68.7,
    height: 62.17,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.434000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 225.65,
    y: 543.255
  }, "\n        Troup\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 104,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 191.3,
    y: 574.34,
    width: 68.7,
    height: 62.72,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.84
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 225.65,
    y: 605.7
  }, "\n        Tattnall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 105,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 191.3,
    y: 637.06,
    width: 68.7,
    height: 62.94,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.993333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 225.65,
    y: 668.53
  }, "\n        Habersham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 106,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 211.89,
    width: 60.59,
    height: 71.42,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.57375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 290.295,
    y: 247.6
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 107,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 320.59,
    y: 211.89,
    width: 61.43,
    height: 71.42,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.238333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 351.30499999999995,
    y: 247.6
  }, "\n        Gilmer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 108,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 382.02,
    y: 211.89,
    width: 61.8,
    height: 71.42,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 412.91999999999996,
    y: 247.6
  }, "\n        Haralson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 109,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 443.82,
    y: 211.89,
    width: 63.74,
    height: 71.42,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.748000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 475.69,
    y: 247.6
  }, "\n        Dooly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 110,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 507.57,
    y: 211.89,
    width: 63.95,
    height: 71.42,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.135714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 539.545,
    y: 247.6
  }, "\n        Lowndes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 111,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 571.52,
    y: 211.89,
    width: 64.16,
    height: 71.42,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.02
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 603.6,
    y: 247.6
  }, "\n        Paulding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 112,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 635.68,
    y: 211.89,
    width: 64.32,
    height: 71.42,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.04
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 667.8399999999999,
    y: 247.6
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 113,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 283.31,
    width: 69.96,
    height: 66.89,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.555714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 294.98,
    y: 316.755
  }, "\n        Pickens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 114,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 350.2,
    width: 69.96,
    height: 68.34,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.593333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 294.98,
    y: 384.37
  }, "\n        Whitfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 115,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 418.54,
    width: 69.96,
    height: 68.88,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.479999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 294.98,
    y: 452.98
  }, "\n        Coweta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 116,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 487.42,
    width: 69.96,
    height: 70,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.994285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 294.98,
    y: 522.4200000000001
  }, "\n        Decatur\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 117,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 557.42,
    width: 69.96,
    height: 71.02,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.994285714285713
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 294.98,
    y: 592.93
  }, "\n        De_Kalb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 118,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 628.44,
    width: 69.96,
    height: 71.56,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.659999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 294.98,
    y: 664.22
  }, "\n        Bartow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 119,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 329.96,
    y: 283.31,
    width: 68.41,
    height: 74.66,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.401666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 364.16499999999996,
    y: 320.64
  }, "\n        Newton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 120,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 398.37,
    y: 283.31,
    width: 72.53,
    height: 74.66,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.088333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 434.635,
    y: 320.64
  }, "\n        Walker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 121,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 470.9,
    y: 283.31,
    width: 75.39,
    height: 74.66,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.443333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 508.59499999999997,
    y: 320.64
  }, "\n        Walton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 122,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 546.3,
    y: 283.31,
    width: 76.15,
    height: 74.66,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 584.375,
    y: 320.64
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 123,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 622.45,
    y: 283.31,
    width: 77.55,
    height: 74.66,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.665714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 661.225,
    y: 320.64
  }, "\n        Laurens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 124,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 329.96,
    y: 357.97,
    width: 73.87,
    height: 81.32,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.311666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 366.895,
    y: 398.63
  }, "\n        Thomas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 125,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 329.96,
    y: 439.29,
    width: 73.87,
    height: 86.3,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.3870000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 366.895,
    y: 482.44
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 126,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 329.96,
    y: 525.58,
    width: 73.87,
    height: 86.9,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.4675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 366.895,
    y: 569.0300000000001
  }, "\n        Cobb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 127,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 329.96,
    y: 612.49,
    width: 73.87,
    height: 87.51,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.23375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 366.895,
    y: 656.245
  }, "\n        Muscogee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 128,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 403.84,
    y: 357.97,
    width: 91.82,
    height: 80.74,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.185
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 449.75,
    y: 398.34000000000003
  }, "\n        Hall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 129,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 495.65,
    y: 357.97,
    width: 101.85,
    height: 80.74,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.534285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 546.5749999999999,
    y: 398.34000000000003
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 130,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 597.5,
    y: 357.97,
    width: 102.5,
    height: 80.74,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.0925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 648.75,
    y: 398.34000000000003
  }, "\n        Gwinnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 131,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 403.84,
    y: 438.71,
    width: 100.56,
    height: 83.38,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.911428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 454.12,
    y: 480.4
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 132,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 403.84,
    y: 522.09,
    width: 100.56,
    height: 88.68,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.736
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 454.12,
    y: 566.4300000000001
  }, "\n        Floyd\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 133,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 403.84,
    y: 610.77,
    width: 100.56,
    height: 89.23,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 22.3075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 454.12,
    y: 655.385
  }, "\n        Bibb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 134,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 504.4,
    y: 438.71,
    width: 93.35,
    height: 110.83,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.66875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 551.0749999999999,
    y: 494.125
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 135,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 597.75,
    y: 438.71,
    width: 102.25,
    height: 110.83,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.607142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 648.875,
    y: 494.125
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 136,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 504.4,
    y: 549.54,
    width: 195.6,
    height: 150.46,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 25.076666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 602.1999999999999,
    y: 624.77
  }, "\n        Fulton\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1904);
export default __webpack_public_path__ + "static/media/1904.5238bd503dcfe2b3948f85ab400c5c2d.svg";
export { ForwardRef as ReactComponent };